import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";

/**
 * @file Created on Fri Feb 15 2019
 * @author SKu
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { FavouriteConverter, jsonConversions } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import logger from '../../logger';
export var FavoriteLayer = function FavoriteLayer() {
  var _this = this;

  _classCallCheck(this, FavoriteLayer);

  /**
   * Get all favorites items for entity
   * @param entity {FavouriteEntityEnum} - query parameter
   */
  this.findAll = function (entity) {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var _this2 = this;

      var _ref, data, favoriteArray;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.FAVORITES)).get({
                responseType: 'json',
                params: {
                  entity: entity
                }
              });

            case 3:
              _ref = _context.sent;
              data = _ref.data;
              favoriteArray = (data || []).map(function (fav) {
                return _this2.converter.toObject(fav, jsonConversions);
              });
              return _context.abrupt("return", favoriteArray);

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              logger.error(_context.t0);
              Promise.reject(_context.t0);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));
  };
  /**
   * Get one favorites item for entity, depending on entityId
   * @param entity {FavouriteEntityEnum} - query parameter
   * @param entityId {string}
   */


  this.findOne = function (entity, entityId) {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var _ref2, data;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.FAVORITES, "/").concat(entityId)).get({
                responseType: 'json',
                params: {
                  entity: entity
                }
              });

            case 3:
              _ref2 = _context2.sent;
              data = _ref2.data;
              return _context2.abrupt("return", this.converter.toObject(data, jsonConversions));

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              logger.error(_context2.t0);
              Promise.reject(_context2.t0);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 8]]);
    }));
  };
};

__decorate([Inject, __metadata("design:type", FavouriteConverter)], FavoriteLayer.prototype, "converter", void 0);